module.exports = __webpack_public_path__ + "static/logo-dcbd31851d5f81356f0e5fdcc8a959ba.png";